import { render, staticRenderFns } from "./PhotoCounting.vue?vue&type=template&id=dd7be50e&scoped=true"
import script from "./PhotoCounting.vue?vue&type=script&lang=js"
export * from "./PhotoCounting.vue?vue&type=script&lang=js"
import style0 from "./PhotoCounting.vue?vue&type=style&index=0&id=dd7be50e&prod&scoped=true&lang=css"
import style1 from "./PhotoCounting.vue?vue&type=style&index=1&id=dd7be50e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7be50e",
  null
  
)

export default component.exports